import React from "react";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@edusogno/primitives/avatar";
import useOneToOne from "@/utils/hooks/useOneToOne.ts";
import dayjs from "dayjs";
import StepBox from "@/components/one-to-one/StepBox.tsx";
import BookingDate from "@edusogno/composites/booking-date";
// import tutorPic2 from "@/assets/img/tutorPic1.png";
import { options, topics } from "@/components/one-to-one/Constants.tsx";
import { t } from "i18next";

interface Props {
  children?: React.ReactNode;
  isLastStep?: boolean;
}

const OneToOneSectionLayout = ({ children, isLastStep }: Props) => {
  // const [tutorToken, setTutorToken] = useState<string>("");
  // const { t } = useTranslation();
  const {
    date,
    hour,
    tutor,
    selectedPreviousTutor,
    category,
    topic,
    tutorSelected,
  } = useOneToOne();
  const newDate = dayjs(date);
  const categoryItem = options[Number(category)];

  return (
    <div className={"w-full  h-full flex gap-4"}>
      <div className={"h-full w-full bg-white  rounded-md"}>
        <div
          className={
            "w-full h-full flex-col justify-between items-center flex bg-white rounded-md py-8 px-6"
          }
        >
          <>{children}</>
        </div>
      </div>
      <div
        className={
          "@container w-full rounded-[15px] flex-[0_0_320px] h-full  flex flex-col gap-4 justify-between"
        }
      >
        <StepBox>
          <div
            className={
              " flex flex-row gap-4  w-full justify-start items-center"
            }
          >
            <BookingDate
              header={date ? dayjs(date)?.format("ddd") : "12"}
              day={date ? dayjs(date)?.format("DD") : "DD"}
              month={date ? dayjs(date)?.format("MMM") : "MM"}
              className={" max-w-[50px] max-h-[50px]"}
            />
            <p className={"text-secondary text-xs [&>b]:font-semibold"}>
              {t("labels.date_and_time")}:
              <br />
              <b>{newDate?.format("ddd DD/MM/YYYY")?.toUpperCase()}</b> at{" "}
              <br /> <b>{hour}</b>
            </p>
          </div>
        </StepBox>
        <StepBox label={"tutor"}>
          {selectedPreviousTutor ? (
            <div className={"flex  gap-4  flex-row w-full items-center "}>
              <Avatar className={"w-[50px] h-[50px]"}>
                <AvatarImage src={tutorSelected?.image} />
                <AvatarFallback>{tutorSelected?.name.charAt(0)}</AvatarFallback>
              </Avatar>
              <p className={"text-secondary text-xs"}>
                <span className="block">{t("one_to_one.your_tutor")}:</span>
                <b className={"font-semibold text-secondary"}>
                  {tutorSelected?.name}
                </b>
              </p>
            </div>
          ) : (
            tutor && (
              <div className={"flex  gap-4  flex-row w-full items-center "}>
                <Avatar className={"w-[50px] h-[50px]"}>
                  <AvatarImage src={tutorSelected?.image} />
                  <AvatarFallback>
                    {tutorSelected?.name.charAt(0)}
                  </AvatarFallback>
                </Avatar>
                <p className={"text-secondary text-xs"}>
                  <span className="block">{t("one_to_one.your_tutor")}:</span>
                  <b className={"font-semibold text-secondary"}>
                    {tutorSelected?.name}
                  </b>
                </p>
              </div>
            )
          )}
        </StepBox>
        <StepBox label={t("one_to_one.stepbox.category", { defaultValue: "Choose the category" })}>
          {category && (
            <div className={"flex  gap-4  flex-row w-full items-center "}>
              <div
                className={
                  "w-[51px]  flex items-center  rounded-md  bg-primary justify-center text-white h-[51px]"
                }
              >
                {options[Number(category)].icon}
              </div>
              <p className={"text-secondary text-xs"}>
                <span className="block">The category:</span>
                <b className={"font-semibold text-secondary line-clamp-2"}>
                  {categoryItem.text}
                </b>
              </p>
            </div>
          )}
        </StepBox>
        <StepBox label={t("one_to_one.stepbox.topic", { defaultValue: "Choose the topic" })}>
          {topic && (
            <div className={"flex  gap-4  flex-row w-full items-center "}>
              <p className={"text-secondary text-xs"}>
                <span className="block">The topic:</span>
                <b className={"font-semibold text-secondary line-clamp-2"}>
                  {topics[categoryItem.key][topic as unknown as number].title}
                </b>
              </p>
            </div>
          )}
        </StepBox>
        <StepBox isLastStep isLastStepComplete={isLastStep}></StepBox>
      </div>
    </div>
  );
};

export default OneToOneSectionLayout;
